import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    uuid: ''
  },
  mutations: {
    setUuid(state, payload){
      state.uuid = payload.uuid;
    }
  }
})
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js